import React, { useEffect } from 'react'
import Home from "../Home";
import { Accordion, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ReceptionSlip () {
    const [lang] = useTranslation("language");
    useEffect (() => {
        document.body.classList.remove("sidebar-open");
    })
    return (
       <Home>
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    {lang("dailySellout.breakTime")}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="email-settings">
                        <div>
                            <h2>{lang("dailySellout.breakingTime")}</h2>
                            <h3>{lang("dailySellout.updateMessage")}</h3>
                        </div>
                        <div className="row break-time">
                            <div className="col-md-6">{lang("dailySellout.timeOne")}</div>
                            <div className="col-md-6">{lang("dailySellout.listOne")}</div>
                            <div className="col-md-6">{lang("dailySellout.timeTwo")}</div>
                            <div className="col-md-6">{lang("dailySellout.listTwo")}</div>
                        </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            </Home>
    )
}

export default ReceptionSlip